import { api } from './client';

export interface ArtifactInfo {
  url: string;
  arch: string;
  size: number;
  sha256: string;
}

export interface ReleaseEntry {
  version: string;
  date: string;
  artifact: ArtifactInfo;
}

export interface ReleasesListResponse {
  releases: ReleaseEntry[];
}

export interface LatestRelease {
  version: string;
  path: string;
  date: string;
}

export interface TempBuildEntry {
  version: string;
  commit: string;
  date: string;
  expiresAt: string;
  artifact: ArtifactInfo;
}

export interface TempBuildsListResponse {
  builds: TempBuildEntry[];
}

export async function listReleases(): Promise<ReleasesListResponse> {
  return api.get('/api/releases');
}

export async function getLatestRelease(): Promise<LatestRelease> {
  return api.get('/api/releases/latest');
}

export async function listTempBuilds(): Promise<TempBuildsListResponse> {
  return api.get('/api/releases/temp');
}
